import { render, staticRenderFns } from "./PermissionGroupItem.vue?vue&type=template&id=dcfed970&scoped=true&"
import script from "./PermissionGroupItem.vue?vue&type=script&lang=js&"
export * from "./PermissionGroupItem.vue?vue&type=script&lang=js&"
import style0 from "./PermissionGroupItem.vue?vue&type=style&index=0&id=dcfed970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfed970",
  null
  
)

export default component.exports